<template>
	<v-content class="main-content-app">
		<router-view />

		<dashboard-core-footer />
	</v-content>
</template>

<script>
	export default {
		name: "DashboardCoreView",

		components: {
			DashboardCoreFooter: () => import("./Footer")
		}
	};
</script>

<style lang="scss" src="../../../../sass/app.scss"></style>
